import { fetchApiDian } from './../../api/ApiRestDian'



async function updateEmpresaSoftware(Id, Pin, Token) {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + Token);

    const raw = JSON.stringify({
        "id": Id,
        "pin": Pin
    });

    const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return await fetchApiDian('/config/software', requestOptions);
}

async function updateEmpresaNominaSoftware(Id, Pin, Token) {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + Token);

    const raw = JSON.stringify({
        "idpayroll": Id,
        "pinpayroll": Pin
    });

    const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return await fetchApiDian('/config/softwarepayroll', requestOptions);
}



async function updateEmpresaPOSSoftware(Id, Pin, Url, Token) {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + Token);

    const raw = JSON.stringify({
        "urleqdocs": Url,
        "ideqdocs": Id,
        "pineqdocs": Pin
    });

    const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return await fetchApiDian('/config/softwareeqdocs', requestOptions);
}

async function updateEmpresaDSSoftware(Id, Pin, Token) {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + Token);

    const raw = JSON.stringify({
        "idsupportdocument": Id,
        "pinsupportdocument": Pin
    });

    const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return await fetchApiDian('/config/softwaresupportdocument', requestOptions);
}


async function updateEmpresaCertificado(Certificado, Password, Token) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + Token);

    const raw = JSON.stringify({
        "certificate": Certificado,
        "password": Password
    });

    const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return await fetchApiDian('/config/certificate', requestOptions);
}


///funcion para crear una resolucion propia
async function updateEmpresaResolucionFactura(ObjetoResolution, Token) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + Token);


   
    const raw = JSON.stringify(ObjetoResolution);

    const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return await fetchApiDian('/config/resolution', requestOptions);
}


///funcion para crear una resolucion propia NC-ND
async function updateEmpresaResolucionNotaDebito_Credito(ObjetoResolution, Token) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + Token);

    console.log(ObjetoResolution);

    const raw = JSON.stringify(ObjetoResolution);

    const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return await fetchApiDian('/config/resolution', requestOptions);
}


///funcion agregar o actualizar el logo de una empresa
async function updateEmpresaLogo(Objeto, Token) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + Token);


    const raw = JSON.stringify(Objeto);

    const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return await fetchApiDian('/config/logo', requestOptions);
}


export {
    updateEmpresaSoftware,
    updateEmpresaCertificado, updateEmpresaResolucionFactura,
    updateEmpresaResolucionNotaDebito_Credito,
    updateEmpresaNominaSoftware,
    updateEmpresaPOSSoftware,
    updateEmpresaLogo,
    updateEmpresaDSSoftware
}